'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('compliance', {
      url: '/account/compliance',
      template: '<compliance></compliance>'
    });
}



// WEBPACK FOOTER //
// ./client/app/account/compliance/compliance.routes.js